import React, { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';
import Input from '../../../components/ui/Input';

const SearchBar = ({ onSearch, isSearching, placeholder }) => {
  const [query, setQuery] = useState('');
  const [suggestions, setSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);

  const popularSearches = [
    'vendor booking',
    'payment methods',
    'cultural traditions',
    'wedding timeline',
    'vendor registration',
    'mobile app',
    'invoice creation',
    'account settings',
    'troubleshooting',
    'refund policy'
  ];

  const mockSuggestions = [
    'How to book a vendor',
    'Payment processing issues',
    'Cultural vendor selection',
    'Wedding planning timeline',
    'Vendor registration process',
    'Mobile app navigation',
    'Invoice template creation',
    'Account management',
    'Technical support',
    'Refund and cancellation'
  ];

  useEffect(() => {
    if (query?.length > 2) {
      const filtered = mockSuggestions.filter(suggestion =>
        suggestion?.toLowerCase().includes(query?.toLowerCase())
      );
      setSuggestions(filtered?.slice(0, 5));
      setShowSuggestions(true);
    } else {
      setSuggestions([]);
      setShowSuggestions(false);
    }
  }, [query]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (query?.trim()) {
      onSearch?.(query?.trim());
      setShowSuggestions(false);
    }
  };

  const handleSuggestionClick = (suggestion) => {
    setQuery(suggestion);
    onSearch?.(suggestion);
    setShowSuggestions(false);
  };

  const handlePopularSearch = (search) => {
    setQuery(search);
    onSearch?.(search);
  };

  return (
    <div className="relative max-w-2xl mx-auto">
      <form onSubmit={handleSubmit} className="relative">
        <div className="relative">
          <Icon 
            name="Search" 
            size={20} 
            className="absolute left-4 top-1/2 transform -translate-y-1/2 text-text-muted" 
          />
          <Input
            type="text"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            placeholder={placeholder || "Search help articles..."}
            className="pl-12 pr-12 py-4 text-lg rounded-full border-2 border-border focus:border-primary"
            disabled={isSearching}
          />
          {isSearching ? (
            <div className="absolute right-4 top-1/2 transform -translate-y-1/2">
              <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-primary"></div>
            </div>
          ) : (
            <button
              type="submit"
              className="absolute right-4 top-1/2 transform -translate-y-1/2 text-primary hover:text-primary-600 transition-colors"
              disabled={!query?.trim()}
            >
              <Icon name="ArrowRight" size={20} />
            </button>
          )}
        </div>
      </form>

      {/* Autocomplete Suggestions */}
      {showSuggestions && suggestions?.length > 0 && (
        <div className="absolute top-full mt-2 w-full bg-white rounded-lg shadow-strong border border-border z-10">
          <div className="py-2">
            {suggestions?.map((suggestion, index) => (
              <button
                key={index}
                onClick={() => handleSuggestionClick(suggestion)}
                className="w-full px-4 py-2 text-left hover:bg-surface-100 transition-colors"
              >
                <div className="flex items-center space-x-3">
                  <Icon name="Search" size={16} className="text-text-muted" />
                  <span className="text-text-primary">{suggestion}</span>
                </div>
              </button>
            ))}
          </div>
        </div>
      )}

      {/* Popular Searches */}
      {!query && (
        <div className="mt-6">
          <p className="text-text-secondary text-sm mb-3">Popular searches:</p>
          <div className="flex flex-wrap gap-2">
            {popularSearches?.map((search, index) => (
              <button
                key={index}
                onClick={() => handlePopularSearch(search)}
                className="px-3 py-1 bg-surface-100 hover:bg-surface-200 text-text-secondary text-sm rounded-full transition-colors"
              >
                {search}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default SearchBar;